import { render } from "./setting.vue?vue&type=template&id=84b2d088&scoped=true&ts=true"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"

import "./setting.vue?vue&type=style&index=0&id=84b2d088&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b2d088"]])

export default __exports__